export default __webpack_public_path__ + "static/media/main-img.46f29f73.svg";